import React from "react";
import ERPSBaseTextField from "../custom/inputs/ERPSBaseTextField";
import ERPSBaseLink from "../custom/inputs/ERPSBaseLink";
import { t } from "i18next";
import { getNumericValue } from "./../../helpers/biller";
import ERPSBaseRadioGroup from "../custom/inputs/ERPSBaseRadioGroup";
import { HStack, ResponsiveBox, Stack, Typography } from "../primitives";

export default function ({
  deliveryMethods,
  handleChangeDeliveryMethods,
  deliveryMethodLists,
  getFormatListItem,
  handleClickDeliveryMethod,
  handleRemoveDeliveryMethod,
  error,
  appliesToItems,
  fiNumber,
  canAddDeliveryMethod = true,
}) {
  return deliveryMethods.map(
    (
      {
        deliveryMethod,
        distributionFormat,
        distributionListCode,
        destinationAttention,
        distributionPhoneNumber,
        distributionExtensionNumber,
        distributionEDIMailbox,
        distributionGroupRcpIndex,
      },
      id
    ) => (
      <React.Fragment key={id}>
        <ResponsiveBox mt={4} mb={-2}>
          <Typography variant="h3">
            {t(
              "erps.billermanagement.label.deilveryMethod",
              "Delivery method "
            ) +
              (id + 2)}
          </Typography>
        </ResponsiveBox>
        <HStack spacing={2}>
          <ERPSBaseTextField
            id={`destinationDeliveryType_${id}`}
            type="text"
            label={t(
              "erps.billermanagement.label.deilveryMethod",
              "Delivery method"
            )}
            className="common__textField__width"
            size="small"
            onChange={handleChangeDeliveryMethods("deliveryMethod", id)}
            required={"true"}
            select={true}
            items={deliveryMethodLists}
            value={deliveryMethod}
            SelectProps={{ native: true }}
            error={!deliveryMethod && error?.[id]?.deliveryMethod}
          />
          <ERPSBaseTextField
            id={`distributionFormat_${id}`}
            type="text"
            label={t("erps.billermanagement.label.format", "Format")}
            className="common__textField__width"
            size="small"
            onChange={handleChangeDeliveryMethods("distributionFormat", id)}
            select={true}
            value={distributionFormat}
            items={getFormatListItem(deliveryMethod)}
            SelectProps={{ native: true }}
          />
          <ERPSBaseTextField
            id={`distributionListCode_${id}`}
            type="text"
            label={t("erps.billermanagement.label.destination", "Destination")}
            className="common__textField__width"
            size="small"
            onChange={handleChangeDeliveryMethods("distributionListCode", id)}
            value={distributionListCode}
            required={"true"}
            error={error?.[id]?.distributionListCode}
            inputProps={{ maxLength: 80 }}
          />
        </HStack>
        <HStack spacing={2}>
          <ERPSBaseTextField
            id={`destinationAttention_${id}`}
            type="text"
            label={t("erps.billermanagement.label.attention", "Attention")}
            className="common__textField__width"
            size="small"
            onChange={handleChangeDeliveryMethods("destinationAttention", id)}
            value={destinationAttention}
            InputLabelProps={{
              shrink: deliveryMethod ? true : false,
            }}
            inputProps={{ maxLength: 30 }}
          />
          <HStack spacing={0}>
            <ERPSBaseTextField
              id={`distributionPhoneNumber_${id}`}
              type="number"
              label={t(
                "erps.billermanagement.label.telNum",
                "Telephone number"
              )}
              className="common__textField__width_v1"
              size="small"
              onChange={handleChangeDeliveryMethods(
                "distributionPhoneNumber",
                id
              )}
              value={distributionPhoneNumber || ""}
              InputLabelProps={{
                shrink: deliveryMethod ? true : false,
              }}
              inputProps={{ maxLength: 10 }}
              onInput={(e) => {
                e.target.value = getNumericValue(e.target.value, 0, 10);
              }}
              error={error?.[id]?.distributionPhoneNumber}
            />
            <ERPSBaseTextField
              id={`distributionExtensionNumber_${id}`}
              type="number"
              label={t("erps.billermanagement.label.ext", "Ext.")}
              className="common__textField__width_ext"
              size="small"
              onChange={handleChangeDeliveryMethods(
                "distributionExtensionNumber",
                id
              )}
              value={distributionExtensionNumber || ""}
              InputLabelProps={{
                shrink: deliveryMethod ? true : false,
              }}
              inputProps={{ maxLength: 5 }}
              onInput={(e) => {
                e.target.value = getNumericValue(e.target.value, 0, 5);
              }}
            />
          </HStack>
        </HStack>
        {deliveryMethod === "EDI" && (
          <HStack spacing={0}>
            <ERPSBaseTextField
              id={`destinationEDIMailbox_${id}`}
              type="text"
              label={t("erps.billermanagement.label.ediMailBox", "EDI mailbox")}
              className="common__textField__width"
              size="small"
              onChange={handleChangeDeliveryMethods(
                "distributionEDIMailbox",
                id
              )}
              value={distributionEDIMailbox}
              InputLabelProps={{
                shrink: deliveryMethod ? true : false,
              }}
              inputProps={{ maxLength: 45 }}
              isDisabled={true}
            />
          </HStack>
        )}
        {(fiNumber == 10 || fiNumber == 16) && (
          <HStack spacing={0}>
            <ERPSBaseRadioGroup
              value={distributionGroupRcpIndex || "C"}
              label={t("erps.billermanagement.appliesTo.text", "Applies to")}
              onChange={handleChangeDeliveryMethods(
                "distributionGroupRcpIndex",
                id
              )}
              items={appliesToItems}
              error={error?.[id]?.distributionGroupRcpIndex}
            />
          </HStack>
        )}

        <HStack spacing={8} mt={3}>
          <ERPSBaseLink
            className="link__blue"
            label={t(
              "erps.billermanagement.label.removeDeilveryMethod",
              "Remove a delivery method"
            )}
            target={""}
            onClick={handleRemoveDeliveryMethod(id)}
          />

          {canAddDeliveryMethod && id < 2 && id === deliveryMethods.length - 1 && (
            <ERPSBaseLink
              className="link__blue"
              label={t(
                "erps.billermanagement.label.addDeilveryMethod",
                "Add a delivery method"
              )}
              target={""}
              onClick={() => handleClickDeliveryMethod()}
            />
          )}
        </HStack>
      </React.Fragment>
    )
  );
}
